// Annotation helpers shared by the diff modules. Marks are written straight onto the
// annotated clones (never the originals — diffSlate clones before diffing).
//
// Leaf marks: diffAdded / diffRemoved (+ diffHunk id) — rendered as classes by
// diffMarksAddin. Elements additionally get a diffBlock prop ('added' | 'removed' |
// 'changed') so block-level wrappers (images, whole tables) can be styled even when
// they contain no text leaves.

// One shared context per compare run so hunk ids are unique across content keys and
// prev/next-change navigation can walk them in order. hunkMeta (author/when) is the
// hover-author stretch — scaffolded via the extra arg, populated in a later phase.
export function createDiffContext() {
	const ctx = {
		hunks: [],
		currentKey: undefined,
		newHunk(kind, extra) {
			const id = ctx.hunks.length;
			ctx.hunks.push({ id, kind, key: ctx.currentKey, ...extra });
			return id;
		},
	};
	return ctx;
}

function markLeaves(node, prop, hunkId) {
	if (Array.isArray(node)) {
		node.forEach((n) => markLeaves(n, prop, hunkId));
		return;
	}
	if (!node || typeof node !== 'object')
		return;
	if (typeof node.text === 'string' && node.type === undefined) {
		node[prop] = true;
		node.diffHunk = hunkId;
		return;
	}
	if (Array.isArray(node.children))
		node.children.forEach((c) => markLeaves(c, prop, hunkId));
}

// Mark every leaf in a subtree as added/removed and stamp the root element with a
// diffBlock status. blockStatus defaults to the mark's own kind; pass 'changed' when
// the node is one half of a modified pair.
export function markSubtree(node, prop, hunkId, blockStatus) {
	markLeaves(node, prop, hunkId);
	if (node && typeof node === 'object' && !Array.isArray(node) && node.type)
		node.diffBlock = blockStatus || (prop === 'diffAdded' ? 'added' : 'removed');
}
